import { createSelector } from 'reselect'

import { RootState } from '../types'

export const selectState = (state: RootState) => state.navMenu

export const getSelectedMenuItem = createSelector(selectState, x => x?.selectedMenuItem)

export const getNavMenuState = (state: RootState, name: string) => state.navMenu?.selectedMenuItem === name
